import PropTypes from "prop-types"
import React from "react"
import Radio from "semantic-ui-react/dist/es/addons/Radio/Radio"
import Container from "semantic-ui-react/dist/es/elements/Container/Container"

const CheckboxYesNo = ({
  checked,
  onChange,
  fluid,
  truthyLabel,
  falsyLabel,
  name,
  toggle,
  reversed,
  ...rest
}) => (
  <Container
    textAlign={fluid ? "center" : "left"}
    style={{ fontWeight: "normal" }}
    {...rest}
  >
    {truthyLabel}
    <Radio
      name={name}
      value={reversed ? "false" : "true"}
      checked={reversed ? !Boolean(checked) : Boolean(checked)}
      onChange={() => {
        toggle(true)
        onChange({}, { value: reversed ? false : true })
      }}
      style={{ marginLeft: "0.5em", marginRight: "0.75em" }}
    />
    <Radio
      name={name}
      value={reversed ? "true" : "false"}
      checked={checked === undefined ? false : reversed ? checked : !checked}
      onChange={() => {
        toggle(false)
        onChange({}, { value: reversed ? true : false })
      }}
      style={{ marginLeft: "0.75em", marginRight: "0.5em" }}
    />
    {falsyLabel}
  </Container>
)

CheckboxYesNo.propTypes = {
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  fluid: PropTypes.bool,
  toggle: PropTypes.func
}

CheckboxYesNo.defaultProps = {
  fluid: false,
  truthyLabel: "Yes",
  falsyLabel: "No",
  reversed: false,
  toggle: () => {},
  onChange: () => {}
}

export default CheckboxYesNo
